module.exports = {
  Hierarchy: require('./hierarchy.js'),
  handlebars: require('./handlebars.js'),
  arrayify: require('./arrayify'),
  getGndId(str) {
    if(str.indexOf('%') != -1) {
      str = decodeURIComponent(str)
    }
    return str.replace('http://d-nb.info/gnd/', '').replace('gnd:')
  },
}
